module.exports = __webpack_public_path__ + "img/032.1dd69744.png";